import React from 'react';
import { bindActionCreators } from 'redux';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import Validator from 'validator';
import { getAllSitePages, getPageData } from '../../Actions/actions';

class TermsAndCondition extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorsTermPolicy: {},
      readDisclaimer: '',
      readPrivacyPolicy: '',
      readLetterOfAgency: '',
      readUserAgreement: '',
      intervalId: 0,
      termsDataState: {},
    };
    this.handleSubmitTermPolicy = this.handleSubmitTermPolicy.bind(this);
    this.moveBack = this.moveBack.bind(this);
    this.AckOnchange = this.AckOnchange.bind(this);
  }

  handleSubmitTermPolicy(e) {
    const {
      readDisclaimer, readUserAgreement, readPrivacyPolicy, readLetterOfAgency,
    } = this.state;
    e.preventDefault();
    if (this.isValidTermPolicy()) {
      this.props.termsAndConditionData({
        readDisclaimer, readUserAgreement, readPrivacyPolicy, readLetterOfAgency,
      });
    }
    const intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    this.setState({ intervalId });
  }

    scrollStep=() => {
      if (window.pageYOffset === 0) {
        clearInterval(this.state.intervalId);
      }
      window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
    }

    componentWillMount() {
      if (this.props.pageType === 'consumer') {
        this.props.getPageData(6);
      }
      if (this.props.pageType === 'business') {
        this.props.getPageData(7);
      }
    }

    moveBack() {
      this.props.termsAndConditionBack();
    }

    isValidTermPolicy() {
      const { errorsTermPolicy, isValidTermPolicy } = this.validateInputTermPolicy(this.state);

      if (!isValidTermPolicy) {
        this.setState({ errorsTermPolicy });
      }
      return isValidTermPolicy;
    }

    validateInputTermPolicy(data) {
      const errorsTermPolicy = {};
      if (Validator.isEmpty(data.readDisclaimer)) {
        errorsTermPolicy.readDisclaimer = 'Required';
        errorsTermPolicy.readDisclaimerError = true;
      }

      if (Validator.isEmpty(data.readPrivacyPolicy)) {
        errorsTermPolicy.readPrivacyPolicy = 'Required';
        errorsTermPolicy.readPrivacyPolicyError = true;
      }

      if (Validator.isEmpty(data.readLetterOfAgency)) {
        errorsTermPolicy.readLetterOfAgency = 'Required';
        errorsTermPolicy.readLetterOfAgencyError = true;
      }

      if (Validator.isEmpty(data.readUserAgreement)) {
        errorsTermPolicy.readUserAgreement = 'Required';
        errorsTermPolicy.readUserAgreementError = true;
      }
      return {
        errorsTermPolicy,
        isValidTermPolicy: isEmpty(errorsTermPolicy),
      };
    }

    componentDidUpdate() {
      const { termsDataState } = this.state;
      const { signupData: { BusinessUserDataStep1 }  } = this.props;
      if (BusinessUserDataStep1.step1 !== undefined) {
        if (termsDataState !== BusinessUserDataStep1) {
          this.setState({
            termsDataState: BusinessUserDataStep1,
            readDisclaimer: BusinessUserDataStep1.step1.readDisclaimer,
            readPrivacyPolicy: BusinessUserDataStep1.step1.readPrivacyPolicy,
            readLetterOfAgency: BusinessUserDataStep1.step1.readLetterOfAgency,
            readUserAgreement: BusinessUserDataStep1.step1.readUserAgreement,
          });
        }
      }
    }

    AckOnchange(e) {
      const name = e.target.name;
      let value = '';
      // const {
      //   readDisclaimer, readPrivacyPolicy, bankAccount, serviceFeeAgree, readLetterOfAgency, readUserAgreement,
      // } = this.state;
      if (name === 'readDisclaimer' && e.target.checked === true) {
        value = '1';
      }
      if (name === 'readPrivacyPolicy' && e.target.checked === true) {
        value = '1';
      }
      if (name === 'readLetterOfAgency' && e.target.checked === true) {
        value = '1';
      }
      if (name === 'readUserAgreement' && e.target.checked === true) {
        value = '1';
      }
      if (name === 'bankAccount' && e.target.checked === true) {
        value = '1';
      }
      if (name === 'serviceFeeAgree' && e.target.checked === true) {
        value = '1';
      }
      this.setState({ [e.target.name]: value, errorsTermPolicy: {}, errors: {} });
    }

    render() {
      const { errorsTermPolicy } = this.state;
      const { pageDetails } = this.props.data;
      return (
        <span>
          <form className="col s12" onSubmit={this.handleSubmitTermPolicy}>
            <p>
              <label>
                <input type="checkbox" name="readUserAgreement" onChange={this.AckOnchange} value="1" checked={this.state.readUserAgreement === '1'} />
                <span>
I have read and agree to the
                  {' '}
                  <a href="/user-agreement" target="_blank">Service Agreement</a>
                </span>

              </label>
              <span className={errorsTermPolicy.readUserAgreementError ? 'show invalid' : 'hide'}>
                {errorsTermPolicy.readUserAgreement}
              </span>
            </p>
            <p className="des">The User Agreement states the terms on which Collectively will provide services.</p>
            <p>
              <label>
                <input
                  type="checkbox"
                  name="readLetterOfAgency"
                  onChange={this.AckOnchange}
                  value="1"
                  checked={this.state.readLetterOfAgency === '1'}
                />
                <span>
I have read and agree to the
                  {' '}
                  <a href="/revocable-letter-of-agency" target="_blank">
Revocable Letter of Agency
              and e-signature consent

                  </a>

                </span>


              </label>
              <span
                className={errorsTermPolicy.readLetterOfAgencyError ? 'show invalid' : 'hide'}
              >
                {errorsTermPolicy.readLetterOfAgency}

              </span>

            </p>
            <p className="des">
The Revocable Letter of Agency appoints Collectively as your agent for purposes of
                                      carrying out the provisions of the Customer Agreement and taking any actions Collectively deems
                                      necessary or advisable to accomplish the purposes of the Customer Agreement.
                    The Revocable Letter of Agency is part of the Customer Agreement and subject to its terms.

            </p>
            <p>
              <label>
                <input
                  type="checkbox"
                  name="readPrivacyPolicy"
                  onChange={this.AckOnchange}
                  value="1"
                  checked={this.state.readPrivacyPolicy === '1'}
                />
                <span>
I have read and agree to the
                  {' '}
                  <a href="https://www.collectivelyapp.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                </span>
              </label>
              <span
                className={errorsTermPolicy.readPrivacyPolicyError ? 'show invalid' : 'hide'}
              >
                {errorsTermPolicy.readPrivacyPolicy}

              </span>
            </p>


            <p>
              <label>
                <input
                  type="checkbox"
                  name="readDisclaimer"
                  onChange={this.AckOnchange}
                  value="1"
                  checked={this.state.readDisclaimer === '1'}
                />
                <span>I have read and agree to the disclaimer below</span>
              </label>
              <span
                className={errorsTermPolicy.readDisclaimerError ? 'show invalid' : 'hide'}
              >
                {errorsTermPolicy.readDisclaimer}

              </span>

            </p>

            <div className="des">Disclaimer</div>
            <div className="des">
              {(pageDetails !== undefined) ? (pageDetails.body !== undefined) ? (
                <p dangerouslySetInnerHTML={{ __html: pageDetails.body }} />) : (
                  <p>
Disclaimer: Collectively is not a law firm and does not give legal advice. Collectively is not associated with the class administrator, the court, class counsel or any other official parties. You do not have to hire a third-party claims consultant and are entitled to file your claim on your own without incurring any fee. For The Payment Card Settlement Only: The Second Circuit Court of Appeals reversed approval of the settlement and returned the case to the District Court on June 30, 2016. Litigation is ongoing. No claim forms are available at this time, and no claim-filing deadline exists. If another settlement is reached, no-cost assistance will be available from the Class Administrator and Class Counsel during any claims-filing period. No one is required to sign up with any third-party service in order to participate in any settlement. For additional information regarding the status of the litigation, interested persons may visit www. paymentcardsettlement.com the Court-approved website for this case.

                  </p>
              ) : (
                <p>
Disclaimer: Collectively is not a law firm and does not give legal advice. Collectively is not associated with the class administrator, the court, class counsel or any other official parties. You do not have to hire a third-party claims consultant and are entitled to file your claim on your own without incurring any fee. For The Payment Card Settlement Only: The Second Circuit Court of Appeals reversed approval of the settlement and returned the case to the District Court on June 30, 2016. Litigation is ongoing. No claim forms are available at this time, and no claim-filing deadline exists. If another settlement is reached, no-cost assistance will be available from the Class Administrator and Class Counsel during any claims-filing period. No one is required to sign up with any third-party service in order to participate in any settlement. For additional information regarding the status of the litigation, interested persons may visit www. paymentcardsettlement.com the Court-approved website for this case.

                </p>
              )}
            </div>


            <p>After your account is created, you will have a copy of these documents available for download from the My Profile management page.</p>


            <div className="col s12 ">
              <div className="divider hdr-bdr " />
            </div>
            <div className="col s12 back-signupbutton">
              <a className={this.props.backButton === true ? ' btn waves-effect waves-light primary-btn col s6 offset-s3 ' : ' hide '} onClick={this.moveBack}>
                <i className="material-icons">arrow_backward</i>
Back
              </a>

              <button
                className="btn waves-effect waves-light primary-btn col s6 offset-s3"
                type="submit"
                name="action"
              >
Go to E-Signature
                <i className="material-icons">arrow_forward</i>
              </button>
            </div>
          </form>

        </span>

      );
    }
}

const mapStateToProps = state => ({
  data: state.data,
  signupData: state.signupData,

});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getAllSitePages, getPageData }, dispatch);

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(TermsAndCondition));
